// extracted by mini-css-extract-plugin
export default {"menu-item":"style_menu-item__y7QdI","menu-item-drawer":"style_menu-item-drawer__-RNzQ","pocontent":"style_pocontent__4zQmu"};